// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"nav_NavigationItem__3P6CJ","active":"nav_active__Gxig5","visited":"nav_visited__1DxtX"};